import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	header: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	saveButtonCaption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	header: {
		id: 'copy-filters-modal.content.header',
		defaultMessage: 'Copy filter {name}',
		description: 'Header of the copy filter modal shown on the filters directory page',
	},
	saveButtonCaption: {
		id: 'copy-filters-modal.content.save-button-caption',
		defaultMessage: 'Copy',
		description: 'Label for the submit button shown in the copy filter modal',
	},
});
export default messages;
